import React from 'react'
import domToHtml from 'dom-serializer'
import parse from 'html-react-parser'
import type { DOMNode, HTMLReactParserOptions } from 'html-react-parser'
import type { TextBlockData } from 'shared/graphql/graphql'
import { isMobile, isMobileWeb } from 'utils/platform'
import { HEADING_REGEX } from './constants'
import CustomTable from './custom-table'
import type { CustomTableProps } from './custom-table/types'
import { TextBlock } from './styles'
import type { CmsTextBlockProps } from './types'

const CmsTextBlock: React.FC<CmsTextBlockProps> = ({ data }) => {
  if (!data) return null

  const { html } = data as TextBlockData

  if (!html) return null

  if (isMobile() || isMobileWeb()) {
    // eslint-disable-next-line fp/no-let -- let used for processing the table headers
    let lastHeading: CustomTableProps['title'] = null

    const options: HTMLReactParserOptions = {
      replace: (domNode: DOMNode) => {
        if (domNode.type === 'tag') {
          if (HEADING_REGEX.test(domNode.name)) {
            // @ts-expect-error - heading encapsulates a span tag
            lastHeading = domNode.children?.[0]?.children?.[0]?.data ?? ''
          }

          if (domNode.name === 'table') {
            const tableHtml = domToHtml(domNode)
            const headingToPass = lastHeading

            lastHeading = null

            return <CustomTable html={tableHtml} title={headingToPass} />
          }
        }

        return null
      },
    }

    return <TextBlock>{parse(html, options)}</TextBlock>
  }

  return <TextBlock>{parse(html)}</TextBlock>
}

export default CmsTextBlock
